(() => {
  const name = 'tooltip';

  App.common = App.common || {};

  App.common[name] = (() => {
    let $tooltip = null;
    const arrowPosition = {};
    const tooltipHtml = `
      <div class="arrow"></div>
      <div class="tooltip__content">
        <div class="tooltip__heading"></div>
        <div class="tooltip__text"></div>
      </div>`;

    const getPositionStatic = function (event) {
      // .jsTooltip DOM element.
      const $button = $(event.currentTarget);
      // DOM element that contains all tooltips inside it's area.
      const $jsTooltipWidget = $button.closest('[data-js-tooltip-widget]');
      const buttonOffset = $button.offset();
      const jsTooltipWidgetOffset = $jsTooltipWidget.offset();
      const cursorHeight = 8;
      const tooltipWidth = $tooltip.outerWidth();

      // Calculate tooltip's left position.
      let tooltipLeft = Math.round(buttonOffset.left + $button.outerWidth() / 2 - tooltipWidth / 2);
      if (tooltipLeft < jsTooltipWidgetOffset.left) {
        // Tooltip's left side is outside of tooltip widget area.
        tooltipLeft = Math.round(jsTooltipWidgetOffset.left);
      } else {
        const widgetRightSide = jsTooltipWidgetOffset.left + $jsTooltipWidget.outerWidth();
        // Tooltip's right side is outside of tooltip widget area.
        if (tooltipLeft > widgetRightSide - tooltipWidth) {
          tooltipLeft = Math.round(widgetRightSide - tooltipWidth);
        }
      }

      // Calculate tooltip's top position.
      let tooltipTop;
      switch ($button.data('placement')) {
        case 'bottom': {
          tooltipTop = Math.round(buttonOffset.top + $button.outerHeight() + cursorHeight);
          break;
        }
        case 'top':
        default: {
          tooltipTop = Math.round(buttonOffset.top - $tooltip.outerHeight() - cursorHeight);
        }
      }

      // Calculate tooltip's arrow left position.
      arrowPosition.left = Math.round(buttonOffset.left + $button.outerWidth() / 2 - tooltipLeft);

      return {
        left: tooltipLeft,
        top: tooltipTop,
      };
    };

    const getPositionNearCursor = (e) => {
      const event = e.type === 'touchend' ? e.changedTouches[0] : e;
      const { pageX, pageY } = event;
      const yPos = pageY - 5;
      const xPos = (window.innerWidth - pageX) >= 125
        ? pageX + 10
        : pageX - $tooltip.outerWidth() - 5;
      return {
        top: yPos,
        left: xPos,
      };
    };

    const getPositionNearCursorEdge = ($jsTooltip) => {
      const { top, left } = $jsTooltip.offset();
      return {
        top: top + 5,
        left: (window.innerWidth - left) >= 125
          ? left + 25
          : left - $tooltip.outerWidth() - 5,
      };
    };

    const getDynamicCursorPosition = (event) => (
      App.global.isEdgeBrowser() ? getPositionNearCursorEdge($(event.currentTarget)) : getPositionNearCursor(event)
    );

    const hide = () => {
      $tooltip.addClass('d-none');
      $(document).off('click', hide);
    };

    const getAttributes = ($target) => {
      const data = $target.data();
      const attributes = {};

      attributes['data-heading'] = !!data.heading;
      attributes['data-static'] = !!data.static;

      if (data.static) {
        // Remove d-none class from the class list
        attributes.class = `${$tooltip.attr('class')} opacity0`.replace('d-none', '');
      }
      if (data.placement) {
        attributes['data-placement'] = data.placement;
      }
      return attributes;
    };

    const getStyles = (event, data) => {
      let styles = {};

      if (data.static) {
        styles = { ...styles, ...getPositionStatic(event) };
      } else {
        styles = { ...styles, ...getDynamicCursorPosition(event) };
      }
      return styles;
    };

    const refreshTooltip = ({ e, $target, data }) => {
      if (data.heading) {
        $tooltip.find('.tooltip__heading').text(data.heading);
      }
      $tooltip.find('.tooltip__text').html(data.text);
      // Need calculate position 2 times:
      // first time with class opacity0 (when tooltip's opacity is 0) to get correct tooltip's dimensions
      // second - correctly position tooltip and show it (remove class opacity0 and d-none).
      $tooltip
        .removeClass('d-none')
        .css(getStyles(e, data))
        .attr(getAttributes($target))
        .css(getStyles(e, data))
        .removeClass('opacity0');

      if (data.static) {
        $('.arrow', $tooltip).css(arrowPosition);
      }
    };

    const setEventListeners = () => {
      if (App.global.isDesktop()) {
        $(document)
          .on('mouseover', '.js-tooltip', (e) => {
            const $target = $(e.currentTarget);
            const data = $target.data();

            if (!data.text) return;

            refreshTooltip({ e, $target, data });

            // Set tooltip's event listeners.
            $target.on('mouseout', () => {
              $tooltip.addClass('d-none');
              $target.off('mousemove mouseout');
            });

            if (!data.static) {
              $target.on('mousemove', (event) => {
                $tooltip.css(getStyles(event, data));
              });
            }
          });
      } else {
        $(document)
          .on('touchend', '.js-tooltip', (e) => {
            const $target = $(e.currentTarget);
            const data = $target.data();

            e.preventDefault();
            e.stopPropagation();

            if (!data.text) return;

            refreshTooltip({ e, $target, data });

            $(document).on('click', hide);
          });

        $(window).on('scroll orientationchange', hide);
      }
    };

    const init = () => {
      $tooltip = $('<div/>', {
        id: 'tooltip',
        class: 'd-none',
        html: tooltipHtml,
      })
        .appendTo('body');
      setEventListeners();
    };

    return {
      init,
    };
  })();
})();
